import React from 'react';
import styled, { keyframes } from 'styled-components';

const scroll = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const MarqueeWrapper = styled.div`
  width: 80%;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
`;



const MarqueeContainer = styled.div`
  width: 100%;
  overflow: hidden;
  background: transparent;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    opacity: 0.6;
  }
`;

const MarqueeContent = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  animation: ${scroll} 30s linear infinite;
  gap: 3rem;
  width: fit-content;
`;


const SubscriptionCard = styled.div`
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 0.75rem 1.5rem;
  transition: all 0.3s ease;
  min-width: 200px;
  
  &:hover {
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(59, 130, 246, 0.5);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
  }
`;

const ServiceIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  font-size: 1.2rem;
  flex-shrink: 0;
  font-weight: bold;
  
  &.netflix {
    background: #e50914;
    color: white;
  }
  
  &.spotify {
    background: #1db954;
    color: white;
  }
  
  &.apple {
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: white;
  }
  
  &.disney {
    background: #113ccf;
    color: white;
  }
  
  &.prime {
    background: #232f3e;
    color: #ff9900;
  }
  
  &.hulu {
    background: #1ce783;
    color: white;
  }
`;

const ServiceInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ServiceName = styled.span`
  font-family: 'Very Sans', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 0.1rem;
`;

const ServicePrice = styled.span`
  font-family: 'Very Sans', sans-serif;
  font-size: 0.8rem;
  font-weight: 400;
  color: #3B82F6;
`;

const PopularSubs = () => {
  const subscriptions = [
    {
      name: 'Netflix',
      price: '$15.49 Monthly',
      icon: 'N',
      className: 'netflix'
    },
    {
      name: 'Spotify Premium',
      price: '$10.99 Monthly',
      icon: 'S',
      className: 'spotify'
    },
    {
      name: 'Apple Music',
      price: '$10.99 Monthly',
      icon: 'A',
      className: 'apple'
    },
    {
      name: 'Disney+',
      price: '$7.99 Monthly',
      icon: 'D+',
      className: 'disney'
    },
    {
      name: 'Amazon Prime',
      price: '$14.98 Monthly',
      icon: 'P',
      className: 'prime'
    },
    {
      name: 'Hulu',
      price: '$7.99 Monthly',
      icon: 'H',
      className: 'hulu'
    }
  ];

  const duplicatedSubscriptions = [...subscriptions, ...subscriptions, ...subscriptions];

  return (
    <MarqueeWrapper>
      
      
      <MarqueeContainer>
        <MarqueeContent>
          {duplicatedSubscriptions.map((sub, index) => (
            <SubscriptionCard key={`${sub.name}-${index}`}>
              <ServiceIcon className={sub.className}>
                {sub.icon}
              </ServiceIcon>
              <ServiceInfo>
                <ServiceName>{sub.name}</ServiceName>
                <ServicePrice>{sub.price}</ServicePrice>
              </ServiceInfo>
            </SubscriptionCard>
          ))}
        </MarqueeContent>
      </MarqueeContainer>
    </MarqueeWrapper>
  );
};

export default PopularSubs;